import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

export const PrivateRoute: React.FC<{ children: React.ReactNode; roles?: string[] }> = ({
  children,
  roles,
}) => {
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);
  const location = useLocation();
  const isTeacherArea = location.pathname.startsWith('/teacher');
  const isStudentArea = location.pathname.startsWith('/student');

  if (!isAuthenticated || !user) {
    return (
      <Navigate
        to={isTeacherArea ? '/teacher/login' : isStudentArea ? '/student/login' : '/login'}
        state={{ from: location }}
        replace
      />
    );
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={isTeacherArea ? '/teacher/login' : '/student/login'} replace />;
  }

  return <>{children}</>;
};
